<!--
 * @Author: your name
 * @Date: 2020-11-05 14:40:45
 * @LastEditTime: 2021-03-18 13:44:15
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \znjz-vue\src\components\index\expertTeam.vue
-->
<template>
<div class="train">
    <swiper :options="trainSwiperOption"  class="type-page">
        <swiper-slide 
           class="swiper-slide" 
           v-cloak 
           v-for="item of trainList"
           :key="item.id"
        >
          <img :src="item.image" alt="">
          <div class="imgBg" :style="{backgroundImage:`url($(item.image)`}"></div>
          <div class="mask">
            <h1>{{item.title}}</h1>
            <button class="btn primary btn-ghost btn-shine" @click="jumpToDetail(item.id)">查看详情</button>
          </div>
        </swiper-slide>
        
    </swiper>
    <div class="swiper-navigation">
      <div class="t-swiper-button-prev" slot="button-prev"><img src="./../../assets/image/right.png" alt=""></div>
      <div class="t-swiper-button-next" slot="button-next"><img src="./../../assets/image/right.png" alt=""></div>
    </div>
      <div class="swiper-paginations type-page"></div>
      <p class="train-title">
        实训基地   
        <span>Training base</span>
        <router-link to="/trainingBase" class="link">More +</router-link>
      </p>
  </div>
</template>

<script>
let vm = this
export default {
    props: ['trainList'],
    data(){
        return {
             trainSwiperOption:{
                //显示分页
                pagination: {
                     el: '.swiper-paginations',
                     clickable :true,     //点击分页切换
                },
                // loop: true,
                slidesPerView: 3,
                autoplay: {   //自动切换的时间
                    delay: 300000,
                    // disableOnInteraction: false,   //自动切换不会停止
                },
                //设置点击箭头
                navigation: {
                    nextEl: '.t-swiper-button-next', 
                    prevEl: '.t-swiper-button-prev'
                },
                initialSlide :1,        //默认显示第一页 
                preventClicksPropagation : true,
                    on:{
                        // click (){
                        //     const realIndex = this.realIndex;
                        //      vm.handleClickSlide(vm.swiperBanner[realIndex])
                        // },
                    },
            }
        }
    },
    methods: {
        jumpToDetail(id){
            this.$router.push({
                path: '/baseDetail',
                query: {
                    id: id
                }
            })
        }
    }
}
</script>

<style scoped lang="scss">
.type-page {
  width: 60%;
  max-width:1200px
}
.train {
    padding: 70px 0 30px;
    background: #fff;
    position: relative;
}
 .swiper-container {
    height: 282px;
    margin-bottom: 36px;
   
}
.swiper-slide {
   .imgBg {
       width: 100%;
       height: 282px;
   }
   &:hover .mask {
    top: 0;
    bottom: 0;
    z-index: 111;
  }

}

>>>.swiper-paginations {
  position:relative;
  z-index: 11;
}
>>> .swiper-pagination-clickable .swiper-pagination-bullet {
    margin: 0 5px ;
}
.swiper-navigation{
  width: 100% ;
	position: absolute;
	top: 16%;
  z-index: 13;
  
}
.t-swiper-button-prev ,.t-swiper-button-next{
    width: 20%;
    height: 282px;
    position: absolute;
    top: 0;
    z-index: 12;
    text-align: center;
    
    img {
      position: absolute;
      top: 50%;
      margin-top: -20px;
    }
}
.t-swiper-button-prev{
    top: 0;
    transform: rotate(180deg);
    background-image:linear-gradient(to top,rgba(204,204,204,0.6),rgba(204,204,204,.6)), url(./../../assets/image/train_left.png);
    &:hover {
      background-image:linear-gradient(to top,rgba(65,101,255,0.6),rgba(65,101,255,.85)), url(./../../assets/image/train_left.png);
    }

}
 .t-swiper-button-next {
    right:0; 
    background-image:linear-gradient(to top,rgba(204,204,204,0.6),rgba(204,204,204,.6)), url(./../../assets/image/train_right.png);
    &:hover {
      background-image:linear-gradient(to top,rgba(65,101,255,0.6),rgba(65,101,255,.85)), url(./../../assets/image/train_right.png);
    }
}
>>> .swiper-pagination-bullet-active {
  background-color: #4165FF;
}

  .t-swiper-button-prev:after, .t-swiper-button-next:after {
    display: none;
}
>>> :focus{
  outline:none;
}
.mask {
  height: 100%;
  width: 100%;
  background-color: rgba(0,0,0,.65);
  color: #fff;
  z-index: 13;
  position: absolute;
  top: 100%;
  bottom: 0;
  right: 0;
  left: 0;
  transition: 0.6s linear;
  padding: 32px;
}
.train-title {
  width: 1200px;
  position: absolute;
  bottom: 30px;
  left: 50%;
  margin-left: -600px;
  text-align: center;
  line-height: 19px;
  font-size: 18px;
  font-weight: bold;
  color: #2B2F37;
  span {
    color: #999;
    font-size: 14px;
    font-weight: 0;
  }
  .link {
  position: absolute;
  color: #4165FF;
  right: 0;
  font-weight: 400;
  font-size: 14px;
   cursor: pointer;
}
}

</style>


// WEBPACK FOOTER //
// src/components/index/train.vue